import i18next from 'i18next'
import { BankOutlined, DownloadOutlined, ShoppingOutlined, WarningOutlined } from '@ant-design/icons'

import { LKRoutesEnum } from 'shared/constants/routes'

import { LKGeneralLayoutKeys } from './types'

const getKey = (key: string) => `${LKGeneralLayoutKeys.LKGeneralLayout}.${key}`

export const enum MenuKeys {
  orders = LKRoutesEnum.orders,
  pvz = LKRoutesEnum.pvz,
  tickets = LKRoutesEnum.tickets,
  pwa = 'pwa',
}

export const menuItems = [
  { key: MenuKeys.orders, label: i18next.t(getKey('Заявки')), icon: <ShoppingOutlined /> },
  { key: MenuKeys.pvz, label: i18next.t(getKey('ПВЗ')), icon: <BankOutlined /> },
  {
    key: MenuKeys.tickets,
    label: i18next.t(getKey('Тикеты')),
    icon: <WarningOutlined />,
  },
  {
    key: MenuKeys.pwa,
    label: i18next.t(getKey('Установить')),
    icon: <DownloadOutlined />,
  },
]
